import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import {
  DialogTypeEnum,
  IDialogConfirm
} from '../../../models/dialog';
import { ILot, Mode } from 'src/app/models/generic';
import { ModeType, LotStatus } from './../../../models/generic';
import { TransferTabs } from './../../../models/tabs';
import { ApiDialogService } from '../../../services/api/api-cdialog.service';
import { TransferFragment } from 'src/app/models/tabs';
import { ApiLotDetailService } from '../../../services/api/api-lot-detail.service';

@Component({
  selector: 'app-card-lotes',
  templateUrl: './card-lotes.component.html',
  styleUrls: ['./card-lotes.component.scss']
})
export class CardLotesComponent implements OnChanges {
  @Input() lote!: ILot;
  @Input() tabType: number | string = 1;
  @Input() mode!: ModeType;

  Mode = Mode;
  TransferTabs = TransferTabs;
  TransferFragment = TransferFragment;
  LotStatus = LotStatus;

  lotStatus: string = '';
  lotsForm!: FormGroup;

  constructor(
    private _dialogService: ApiDialogService,
    private _router: Router,
    private _lotDetailService: ApiLotDetailService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.buildForm();
    this.lotStatus = this.lote.StatusOfOnlending?.toLowerCase().trim() ?? '';

    if (this.lotsForm) {
      this.lotsForm.patchValue(this.lote);
    }
  }

  buildForm(): void {
    this.lotsForm = new FormGroup({
      LotId: new FormControl(null),
      LotStatusPayment: new FormControl(null),
      LotPartner: new FormControl(null),
      LotDate: new FormControl(null),
      LotBank: new FormControl(null),
      LotValueTransfer: new FormControl(null),
      QtdeContracts: new FormControl(null),
      SaleChannel: new FormControl(null),
      StatusTransfer: new FormControl(null),
      Checked: new FormControl(false)
    });
  }

  get checkedControl() {
    return this.lotsForm.get('Checked') as FormControl;
  }

  routeToDetails(lotId: string, type: 'Manual' | 'Automatic'): void {
    if (this.lote?.IntegrationError)
      this.openErrorConfirmationDialog(lotId, type);
    else this._lotDetailService.routeToDetailEvent.next({ lotId, type: type });
  }

  openErrorConfirmationDialog(
    lotId: string,
    type: 'Manual' | 'Automatic'
  ): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Erro de integração',
        title: `${this.lote?.IntegrationMsg || '-'}`,
        confirm: 'Editar',
        dismiss: 'Voltar'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this._lotDetailService.routeToDetailEvent.next({ lotId, type: type });
      }
    });
  }
}
